module.exports = __webpack_public_path__ + "assets/images/04_0558cc2a91ee8008af59ed88e3dec723.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-one/gameplay/04.png
// module id = 207
// module chunks = 0